import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import api from '../../../utils/api';

export const StopSIPModal = ({ show, onHide, isCheckFolioResponse, setStopSIP, selectedstopSIPFund, roomId, isFiltered }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  // console.log("isCheckFolioResponse", isCheckFolioResponse, selectedstopSIPFund);

  const [isModalTitle, setIsModalTitle] = useState('');
  const [selectedSIPs, setSelectedSIPs] = useState([]);

  const [totalSIPAmount, setTotalSIPAmount] = useState(0);
  // console.log(selectedSIPs,totalSIPAmount);

  useEffect(() => {
    if (isCheckFolioResponse.matchStatus === 'success') {
      let newStr;
      const str = selectedstopSIPFund?.fund_name;

      if (str?.includes('Fund')) {
        newStr = str.substring(0, str.indexOf('Fund') + 'Fund'.length);
      } else {
        newStr = str;
      }

      const selectedText = `${newStr} (${selectedstopSIPFund?.folio_number}) | Current Value : ${Math.round(
        Number(selectedstopSIPFund?.aum_as_per_rta)
      )}`;
      setIsModalTitle(selectedText);
    }
  }, [isCheckFolioResponse, selectedstopSIPFund]);

  const handleCheckboxClick = (amount, transId, date) => {
    // const formatedDate=moment(date).format('DD/MM/YYYY')
    setSelectedSIPs((prevSelectedSIPs) => {
      const isSelected = prevSelectedSIPs.some((sip) => sip.transId === transId);
      console.log("isSelected", isSelected, prevSelectedSIPs, transId);
      if (isSelected) {
        return prevSelectedSIPs.filter((sip) => sip.transId !== transId);
      } else {
        return [...prevSelectedSIPs, { transId, amount, date }];
      }
    });
  };

  useEffect(() => {
    if (!show) {
      // Reset everything when modal is closed
      setSelectedSIPs([]);
      setTotalSIPAmount(0);
      setIsModalTitle('');
      setStopSIP(true)
      reset(); // from react-hook-form
    }
  }, [show]);

  useEffect(() => {
    const totalAmount = selectedSIPs.reduce((sum, sip) => sum + sip.amount, 0);
    setTotalSIPAmount(totalAmount);
    console.log('selectedSIPs', selectedSIPs)
  }, [selectedSIPs]);

  // Destructure necessary data from selectedstopSIPFund and isCheckFolioResponse
  const { uid, fund_name, goal_id, goal_name, folio_number, account_number: accountNumber, bank_name, scheme_code, email_id: email, mobile_number: mobile, investor_name } = selectedstopSIPFund || {};
  const { ucc } = isCheckFolioResponse || {};

  const handleInitiate = async () => {
    const currentYear = new Date().getFullYear();
    const staticTargetYear = isFiltered?.goalYear || currentYear;
    const staticCAGR = parseInt(isFiltered?.expectedReturn);
    const totalMonths = (staticTargetYear - currentYear) * 12;
    const SipStop = parseInt(totalSIPAmount);

    let capitalGrowth = 0;
    let monthEndValue = 0;
    for (let i = 1; i < totalMonths; i++) {
      capitalGrowth = (monthEndValue + SipStop) * staticCAGR / 1200;
      monthEndValue = monthEndValue + capitalGrowth + SipStop;
    }
    monthEndValue += SipStop;

    const deficitAmount = Math.round(monthEndValue);

    const xsip_reg_noArray = [];
    const sipArray = [];
    const xsip_startDate = [];

    selectedSIPs.forEach(sip => {
      xsip_reg_noArray.push(sip.transId);
      sipArray.push(sip.amount);
      xsip_startDate.push(sip.date || sip.formatedDate);
    });



    // Construct the data object for SIP stop
    const allSipStopData = {
      id: selectedstopSIPFund._id,
      // uid: uid?.replace('/', ''),
      uid: uid,
      fundName: fund_name,
      goalId: goal_id,
      staticTargetAmount: isFiltered?.TargetAmount,
      client_id: roomId,
      goal_name: goal_name,
      folioNo: folio_number,
      ifsc_code: selectedstopSIPFund?.ifsc_code,
      allUnit: '',
      numberOfUnit: '',
      ucc,
      email,
      mobile,
      accountNo: accountNumber,
      sipDeficit: deficitAmount,
      goalYear: staticTargetYear,
      schemeCode: scheme_code,
      investorName: investor_name || selectedstopSIPFund?.investor_name || selectedstopSIPFund?.client_name || "UNKNOWN",
      member_id: selectedstopSIPFund?.pan_client_id,
      xsip_reg_noArray,
      sipArray,
      xsip_startDate,
    };

    try {
      const response = await api.post(`advisor/sipStop`, allSipStopData);

      console.log("sip_stop API Response", response.data);


      // if (response.data?.success) {

      onHide(true)
      // console.log('SIP stop data successfully processed.');


      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: "Goal Event Updated.",
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn',
        },
      });
      // } else {
      //   console.error('Failed to process SIP stop data.');
      // }
    } catch (error) {

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: "Goal Event Not Updated.",
        confirmButtonText: 'OK',
        // customClass: {
        //   confirmButton: 'swal-confirm-btn',
        // },
      });
      console.error("Error during API call:", error);
    }
  };

  return (
    <Modal size="lg" show={show} onHide={onHide} className="custom-modal">
      <Modal.Header closeButton style={{ backgroundColor: "#fff", border: 'none' }}>
        <Modal.Title className="text-lg font-semibold text-gray-800 w-full">
          {isModalTitle || "Redeem Fund"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <p className="text-dark text-center w-100 mx-auto py-1" style={{ backgroundColor: "#90ee90" }}>
          {selectedSIPs.length > 0 ? `Stop the existing SIP of ₹${totalSIPAmount}` : 'Stop SIP'}
        </p> */}
        <div className="modal-body" style={{ maxHeight: "20vw", overflowY: "scroll" }}>
          <div className="row" style={{ padding: "10px 28px 0 0", display: "flex" }}>
            <div className="col-md-2 txt-color" style={{ fontWeight: 800 }}>Mode</div>
            <div className="col-md-2 txt-color" style={{ fontWeight: 800 }}>Amt</div>
            <div className="col-md-3 txt-color" style={{ fontWeight: 800 }}>ECS Date</div>
            <div className="col-md-4 txt-color" style={{ fontWeight: 800 }}>Bank Details</div>
            <div className="col-md-1 txt-color" style={{ fontWeight: 800 }}>Stop?</div>
          </div>
          {isCheckFolioResponse.allactivesip?.map((sip, index) => (
            <div className="row" key={index} style={{ padding: "10px 28px 0 0", display: "flex" }}>
              <div className="col-md-2 txt-color">{sip.type}</div>
              <div className="col-md-2 txt-color">{sip.sip_amount}</div>
              <div className="col-md-3 txt-color">{moment(sip.sip_startdate).format('MMMM Do YYYY')}</div>
              {/* <div className="col-md-3">{moment(sip.sip_startdata).format('DD/MM/YYYY')}</div> */}
              <div className="col-md-4 txt-color">{`${bank_name} AC no: ${accountNumber}`}</div>
              <div className="col-md-1 txt-color">
                <input
                  type="checkbox"
                  disabled={sip.type === 'Offline'}
                  onClick={() => handleCheckboxClick(sip.sip_amount, sip.xsip_reg_no, sip.sip_startdate, sip)}
                // disabled={sip.type !== 'Online'}
                />
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <button
          type="submit"
          className="smlbutton px-4 text-white text-uppercase"
          style={{ backgroundColor: selectedSIPs.length === 0 ? '#6c757d' : '#23674b' }}
          disabled={selectedSIPs.length === 0}
          onClick={handleInitiate}
        >
          Initiate
        </button>
      </Modal.Footer>
    </Modal>
  );
};
